import differenceInCalendarDays from 'date-fns/differenceInCalendarDays'

export const calculateTotalBudget = (dailyBudget: number, [start, end]: [Date | string, Date | string]): number =>
  start && end ? dailyBudget * (differenceInCalendarDays(new Date(end), new Date(start)) + 1) : 0

export const calculateDailyBudget = (totalBudget: number, [start, end]: [Date | string, Date | string]): number =>
  start && end ? totalBudget / (differenceInCalendarDays(new Date(end), new Date(start)) + 1) : 0
